<template>

  <div v-if="tourAccommodation">

    <form class="form" v-on:submit.prevent="updateTourAccommodation">

    <h1>Tour Accommodation<span v-if="tourAccommodation.tour"> on <router-link :to="{ name: 'tour-edit', params: { id: tourAccommodation.tour.id }}">{{ tourAccommodation.tour.name }}</router-link></span><span v-else> on <router-link :to="{ name: 'tour-group', params: { id: tourAccommodation.tour_group.id }}">Tour group</router-link></span></h1>

      <div class="box">

        <Errors/>

        <fieldset>
          <div class="form-wrap">

            <div>
              <label>Accommodation</label>
              <v-select
                v-model="tourAccommodation.accommodation_id"
                :options="accommodations"
                label="accommodation_name"
                id="accommodation"
                index="id"
              />
            </div>

            <div>
              <label for="check_in_day">Check-in day</label>
              <input id="check_in_day" type="number" v-model="tourAccommodation.check_in_day" :min="1" required>
            </div>

            <div>
              <label for="check_out_day">Check-out day</label>
              <input id="check_out_day" type="number" v-model="tourAccommodation.check_out_day" :min="1" required>
            </div>

          </div>
        </fieldset>

        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button"><span>Update</span></button>
          </div>
        </div>


      </div>

    </form>

    <template>
      <h2>Rooms</h2>

      <div class="box">

        <form class="form" v-on:submit.prevent="saveRoom">

          <fieldset>

            <div class="form-wrap">
              <div>
                <label>Rooms</label>
                <v-select
                  v-model="newRoom"
                  :options="accommodationsRooms"
                  label="name"
                />
              </div>
              <div v-if="newRoom">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="newRoom.name" disabled class="fw-bold">
              </div>

              <div v-if="newRoom">
                <label for="board-basis">Board basis</label>
                <input type="text" id="board-basis" v-model="newRoom.board_basis" disabled class="fw-bold">
              </div>

              <div v-if="newRoom">
                <label for="occupancy">Occupancy</label>
                <input id="occupancy" type="number" v-model="newRoom.occupancy" min="1" disabled class="fw-bold">
              </div>

              <!-- <div>
                <label for="availability">Availability</label>
                <input id="availability" type="number" v-model="newRoom.availability" min="1">
              </div>

              <div>
                <label for="supplement">Supplement</label>
                <input id="supplement" type="number" v-model="newRoom.supplement">
              </div> -->

              <div class="form-submit-inline">
                <div v-if="this.getLoadStatus">
                  <button type="submit" class="button" disabled><span>Adding room...</span></button>
                </div>
                <div v-else>
                  <button type="submit" class="button"><span>Add room</span></button>
                </div>
              </div>
            </div>

          </fieldset>

        </form>

        <table class="table" cellspacing="0" cellpadding="0" v-if="tourAccommodation.rooms">
          <thead v-if="tourAccommodation.rooms.length > 0">
            <tr>
              <th>Room name</th>
              <th>Board basis</th>
              <th>Occupancy</th>
              <!-- <th>Availability</th> -->
              <th>Supplement (£)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <!-- <RoomTableRow v-for="room of tourAccommodation.rooms" :key="'room-' + room.id" :room="room"/> -->
            <TourAccomodationRooms :tourAccomodationRooms="tourAccommodation.rooms"/>
<!--  
            <tr v-for="room of tourAccommodation.rooms" :key="room.id">
              <td><input type="text" v-model="room.name"></td>
              <td><input type="text" v-model="room.board_basis"></td>
              <td><input type="number" v-model="room.occupancy"></td>
              <td><input type="number" v-model="room.availability"></td>
              
            </tr> -->
          </tbody>
        </table>

      </div>

    </template><!-- / rooms -->
  </div><!-- / accom -->

</template>

<script>
// @TODO: Finish implementing inheritance of tour accommodation on groups and instances. Mistral should be able to reuse already existing accommodation and only have to overide individual values when needed (in particular: availability and supplements). They should also be able to disable rooms for some groups/instances or add entirely new room options.
import Errors from '@/components/Errors.vue'
import RoomTableRow from '@/components/RoomTableRow.vue'
import TourAccomodationRooms from '@/components/Tour/TourAccomodationRooms.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'TourAccommodationEdit',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      tourAccommodation: null,
      accommodations: [],
      errors: null,
      newRoom: null,
      accommodationsRooms: [],
    }
  },
  components: {
    Errors,
    RoomTableRow,
    TourAccomodationRooms
  },
  created () {
    this.getTourAccommodation()
    /*this.getAccommodation()*/
  },
  watch: {
    '$route': 'getTourAccommodation'
  },
  methods: {
    getTourAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/accommodation/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.tourAccommodation = response.data
        console.log("TA "+this.tourAccommodation[0])
        this.tourAccommodation = this.tourAccommodation[0]

        const filteredArray = this.tourAccommodation.accommodation_rooms.filter(item1 => !this.tourAccommodation.rooms.some(item2 => item1.id === item2.accommodation_room_id));
        this.accommodationsRooms = filteredArray;

        this.getAccommodation(this.tourAccommodation.accommodation_id)
      })
    },
    updateTourAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/accommodation/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.tourAccommodation),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    getAccommodation (accommodation_id) {
        console.log("A "+accommodation_id)
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/' + accommodation_id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.accommodations = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    saveRoom () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/accommodation/' + this.$route.params.id + '/rooms', {
        method: 'POST',
        body: JSON.stringify(this.newRoom),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$notify({
          type: 'success',
          title: response.message
        });
        // Rest the newRoom To null after save room
        this.newRoom = null;
        this.getTourAccommodation()
        this.$store.dispatch('setLoadStatus')
      })
    },
    deleteRoom () {
      this.getTourAccommodation()
    }
  }
}
</script>
